<template>
  <div class="wrapper">
    <!-- 返回按钮 -->
    <div class="back-btn-box" style="margin-bottom: 40px;">
      <button-a
        class="goBackBtn"
        color="#707070"
        bgcolor="transparent"
        @click.native="$router.go(-1)"
      >
        <i class="el-icon-back"></i> 返回列表
      </button-a>
    </div>
    
    <!-- 员工基本信息 -->
    <div class="basic-info white-box">
      <div class="avatar">
        <div class="avatar-circle">{{ getAvatarText(infodata.realName) }}</div>
      </div>
      <div class="info-content">
        <h2>{{ infodata.realName }}</h2>
        <div class="info-grid">
          <div class="info-item">
            <span class="info-label">证件类型：</span>
            <span class="info-value">{{ CardType }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">证件号码：</span>
            <span class="info-value">{{ infodata.idCard }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">手机号码：</span>
            <span class="info-value">{{ infodata.mobilePhone }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">电子邮箱：</span>
            <span class="info-value">{{ infodata.email }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">所属企业：</span>
            <span class="info-value">{{ infodata.customerName }}</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 基础信息 -->
    <div class="info-section white-box">
      <div class="section-title">
        <span class="title-icon">|</span>
        <h3>基础信息</h3>
      </div>
      <div class="info-grid">
        <div class="info-item">
          <span class="item-label">性别</span>
          <span class="item-value">{{ infodata.sex }}</span>
        </div>
        <div class="info-item">
          <span class="item-label">出生日期</span>
          <span class="item-value">{{ infodata.birthday && date(infodata.birthday) }}</span>
        </div>
        <div class="info-item">
          <span class="item-label">国籍</span>
          <span class="item-value">{{ infodata.nationality }}</span>
        </div>
        <div class="info-item">
          <span class="item-label">民族</span>
          <span class="item-value">{{ infodata.nation }}</span>
        </div>
        <div class="info-item">
          <span class="item-label">政治面貌</span>
          <span class="item-value">{{ infodata.politicsStatus }}</span>
        </div>
        <div class="info-item">
          <span class="item-label">婚姻状况</span>
          <span class="item-value">{{ marryStatus }}</span>
        </div>
        <div class="info-item">
          <span class="item-label">生育状况</span>
          <span class="item-value">{{ bearStatu }}</span>
        </div>
        <div class="info-item">
          <span class="item-label">籍贯</span>
          <span class="item-value">{{ infodata.nativePlace }}</span>
        </div>
        <div class="info-item">
          <span class="item-label">户籍类型</span>
          <span class="item-value">{{ domType }}</span>
        </div>
        <div class="info-item">
          <span class="item-label">户籍地址</span>
          <span class="item-value">{{ infodata.domicilePlace }}</span>
        </div>
        <div class="info-item">
          <span class="item-label">现居住地</span>
          <span class="item-value">{{ infodata.liveAddress }}</span>
        </div>
        <div class="info-item">
          <span class="item-label">紧急联系人</span>
          <span class="item-value">{{ employeeICEList[0]?.urgName || employeeICEList[0]?.name || '-' }}</span>
        </div>
        <div class="info-item">
          <span class="item-label">关系</span>
          <span class="item-value">{{ employeeICEList[0]?.relation || employeeICEList[0]?.urgRelation || '-' }}</span>
        </div>
        <div class="info-item">
          <span class="item-label">联系电话</span>
          <span class="item-value">{{ employeeICEList[0]?.mobilePhone || employeeICEList[0]?.urgPhone || '-' }}</span>
        </div>
        <div class="info-item">
          <span class="item-label">联系地址</span>
          <span class="item-value">{{ employeeICEList[0]?.employer || employeeICEList[0]?.urgAddress || '-' }}</span>
        </div>

      </div>
    </div>
    
    <!-- 在职信息 -->
    <div class="info-section white-box">
      <div class="section-title">
        <span class="title-icon">|</span>
        <h3>在职信息</h3>
      </div>
      <div class="info-grid">
        <div class="info-item">
          <span class="item-label">在职岗位</span>
          <span class="item-value">{{ infodata.jobTitle }}</span>
        </div>
        <div class="info-item">
          <span class="item-label">用工性质</span>
          <span class="item-value">{{ empersonalPros }}</span>
        </div>
        <div class="info-item">
          <span class="item-label">用工形式</span>
          <span class="item-value">{{ empType }}</span>
        </div>
        <div class="info-item">
          <span class="item-label">入职日期</span>
          <span class="item-value">{{ infodata.entryDate && date(infodata.entryDate) }}</span>
        </div>
      </div>
    </div>
    
    <!-- 学习经历 -->
    <div class="info-section white-box">
      <div class="section-title">
        <span class="title-icon">|</span>
        <h3>学习经历</h3>
      </div>
      <div class="experience-table">
        <div class="table-header">
          <div class="table-cell">入学日期</div>
          <div class="table-cell">毕业日期</div>
          <div class="table-cell">学校名称</div>
          <div class="table-cell">专业</div>
          <div class="table-cell">学历</div>
          <div class="table-cell">证书/奖励</div>
        </div>
        <div 
          v-for="(item, key) in educata" 
          :key="key" 
          class="table-row"
        >
          <div class="table-cell">{{ date(item.beginDate) }}</div>
          <div class="table-cell">{{ date(item.endDate) }}</div>
          <div class="table-cell">{{ item.schoolName }}</div>
          <div class="table-cell">{{ item.major }}</div>
          <div class="table-cell">{{ item.education }}</div>
          <div class="table-cell">{{ item.certificates }}</div>
        </div>
        <div v-show="educata.length == 0" class="table-row">
          <div class="table-cell"></div>
          <div class="table-cell"></div>
          <div class="table-cell"></div>
          <div class="table-cell"></div>
          <div class="table-cell"></div>
          <div class="table-cell"></div>
        </div>
      </div>
    </div>
    
    <!-- 工作经历 -->
    <div class="info-section white-box">
      <div class="section-title">
        <span class="title-icon">|</span>
        <h3>工作经历</h3>
      </div>
      <div class="experience-table">
        <div class="table-header">
          <div class="table-cell">入职日期</div>
          <div class="table-cell">离职日期</div>
          <div class="table-cell">单位名称</div>
          <div class="table-cell">岗位</div>
          <div class="table-cell">离职原因</div>
          <div class="table-cell">证明人及电话</div>
        </div>
        <div 
          v-for="(item, key) in jobExpdata" 
          :key="key" 
          class="table-row"
        >
          <div class="table-cell">{{ date(item.beginDate) }}</div>
          <div class="table-cell">{{ date(item.endDate) }}</div>
          <div class="table-cell">{{ item.enterpriseName }}</div>
          <div class="table-cell">{{ item.jobTitle }}</div>
          <div class="table-cell">{{ item.leaveReason }}</div>
          <div class="table-cell">{{ item.referenceContact }}</div>
        </div>
        <div v-show="jobExpdata.length == 0" class="table-row">
          <div class="table-cell"></div>
          <div class="table-cell"></div>
          <div class="table-cell"></div>
          <div class="table-cell"></div>
          <div class="table-cell"></div>
          <div class="table-cell"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Get } from '@/js/http.js'
import { dateConvert } from '@/js/tool.js'

export default {
  components: {},
  props: {},
  data () {
    return {
      employeeICEList: [],
      infodata: [],
      educata: [],
      jobExpdata: []
    }
  },
  computed: {
    CardType () {
      let ct = this.infodata.idCardType
      if (ct == 1) {
        return '身份证'
      } else if (ct == 2) {
        return '护照'
      } else if (ct == 3) {
        return '其他'
      } else {
        return ''
      }
    },
    marryStatus () {
      let marry = this.infodata.maritalStatus
      if (marry == 1) {
        return '未婚'
      } else if (marry == 2) {
        return '已婚'
      } else if (marry == 3) {
        return '离异'
      } else if (marry == 4) {
        return '丧偶'
      } else {
        return ''
      }
    },
    bearStatu () {
      let bear = this.infodata.bearStatus
      if (bear == 1) {
        return '未育'
      } else if (bear == 2) {
        return '已育'
      } else if (bear == 3) {
        return '怀孕中'
      } else if (bear == 4) {
        return '哺乳期'
      } else {
        return ''
      }
    },
    domType () {
      let dom = this.infodata.domicileType
      if (dom == 1) {
        return '深户'
      } else if (dom == 2) {
        return '城镇户口'
      } else if (dom == 3) {
        return '农村户口'
      } else if (dom == 4) {
        return '港澳台'
      } else if (dom == 5) {
        return '其他'
      } else {
        return ''
      }
    },
    empersonalPros () {
      let emp = this.infodata.empPersonalPro
      if (emp == 1) {
        return '员工派遣'
      } else if (emp == 2) {
        return '岗位外包'
      } else if (emp == 3) {
        return '劳务外包'
      } else if (emp == 4) {
        return '薪酬代发'
      } else if (emp == 5) {
        return '实习生'
      } else if (emp == 6) {
        return '返聘'
      } else if (emp == 7) {
        return '其他'
      } else {
        return ''
      }
    },
    empType () {
      let emp = this.infodata.employeeType
      if (emp == 1) {
        return '全日制用工'
      } else if (emp == 2) {
        return '非全日制用工'
      } else {
        return ''
      }
    },
    emergencyContactName () {
      if (this.employeeICEList && this.employeeICEList.length > 0) {
        return this.employeeICEList[0].urgName || ''
      }
      return ''
    }
  },
  methods: {
    getData () {
      let id = this.$route.params.id
      //员工详情
      Get(`api/v1/employees/${id}`)
        .then(res => {
          this.employeeICEList = res.data.emergencyContacts
          this.infodata = res.data.baseInfo
          this.educata=res.data.learnExperiences
          this.jobExpdata=res.data.jobExperiences
        })
        .catch(() => {})
    },

    // 日期格式转换
    date (dateStr) {
      return dateConvert(dateStr)
    },
    
    // 获取头像文本
    getAvatarText(name) {
      if (!name) return '张'
      return name.charAt(0)
    }
  },

  mounted () {
    this.getData()
  }
}
</script>
<style lang="scss" scoped>
// 布局样式
.wrapper {
  padding: 32px;
  > div {
    margin-bottom: 25px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}

// 返回按钮
.back-btn-box {
  margin-bottom: 40px;
  .goBackBtn {
    font-size: 16px !important;
    border: none !important;
    margin-bottom: 20px;
    border-color: transparent !important;
  }
}

// 白色框
.white-box {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 32px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

// 基本信息
.basic-info {
  display: flex;
  align-items: center;
  .avatar {
    margin-right: 20px;
    .avatar-circle {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      background-color: #dbeafe;
      color: #2576F1;
      font-size: 24px;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .info-content {
    flex: 1;
    h2 {
      font-size: 20px;
      font-weight: bold;
      color: #2576F1;
      margin-bottom: 8px;
    }
    .info-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 8px;
      .info-item {
        display: flex;
        align-items: center;
        .info-label {
          color: #999999;
          margin-right: 4px;
          // width: 80px;
          font-size: 14px;
          text-align: right;
        }
        .info-value {
          color: #4B5563;
          flex: 1;
           font-size: 14px;
        }
      }
    }
  }
}

// 信息section
.info-section {
  .section-title {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    padding: 0px 0;
    .title-icon {
      color: #F26828;
      font-size: 20px;
      font-weight: bold;
      margin-right: 8px;
    }
    h3 {
      font-size: 16px;
      font-weight: bold;
      color: #303133;
      margin: 0;
    }
  }
  
  // 信息网格
  .info-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    .info-item {
      display: flex;
      flex-direction: column;
      .item-label {
        color: #606266;
        font-size: 14px;
        margin-bottom: 4px;
      }
      .item-value {
        color: #303133;
        font-size: 14px;
      }
    }
  }
  
  // 经历表格
  .experience-table {
    width: 100%;
    border-collapse: collapse;
    .table-header {
      display: flex;
      background-color: #F5F7FA;
      border-bottom: 1px solid #EBEEF5;
      .table-cell {
        flex: 1;
        padding: 12px 8px;
        text-align: left;
        font-weight: bold;
        color: #303133;
      }
    }
    .table-row {
      display: flex;
      border-bottom: 1px solid #EBEEF5;
      &:last-child {
        border-bottom: none;
      }
      .table-cell {
        flex: 1;
        padding: 12px 8px;
        text-align: left;
        color: #303133;
      }
    }
  }
}
</style>
